import React from "react"
import image_logo from '../assets/home.jpg'

export default function Header({
    tapLogo
}) {
    return (
        <div
            style={{
                width: '100%',
                height: 'auto',                
            }}>            
            <img 
                src={image_logo} 
                alt="logo"
                style={{
                    maxWidth: '100%',
                    height: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto'                    
                }}
                onClick={tapLogo}
                />                    
        </div>
    )
}